import http from "../../../request";

export default {
  about: async (context) => {
    let response = await http.get("about", localStorage.getItem("lang"));

    context.commit("setAbout", response.data);
  },
};
